import { InputAdornment, makeStyles, TextField } from "@material-ui/core";
import React from "react";
const useStyles = makeStyles(() => ({
  search: {
    "& .MuiOutlinedInput-input": {
      padding: "12.5px 14px",
    },
  },
}));
function MatxSearch({ placeHolder, iconComponent, ...props }) {
  const classes = useStyles();
  return (
    <TextField
      id={`input-with-icon-textfield-${placeHolder}`}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">{iconComponent}</InputAdornment>
        ),
      }}
      fullWidth
      className={`${classes.search} ${props.className}`}
      variant="outlined"
      placeholder={placeHolder}
      {...props}
    />
  );
}

export default MatxSearch;
